import React from "react";
import { Code, ShoppingCart, Layout, Rocket } from "lucide-react";

const services = [
  { icon: <Code size={40} />, title: "Business Websites", desc: "Responsive and professional websites for businesses." },
  { icon: <ShoppingCart size={40} />, title: "E-commerce", desc: "Online stores with modern UI and secure checkout." },
  { icon: <Layout size={40} />, title: "Portfolio & Landing Pages", desc: "Showcase your work or launch your product." },
  { icon: <Rocket size={40} />, title: "Website Redesign", desc: "Upgrade and optimize your existing website." },
];

const Services = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-6 max-w-7xl">
        <h2 className="text-4xl font-extrabold text-center text-gray-900 mb-16">
          Our Services
        </h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-10">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gradient-to-tr from-white to-indigo-50 p-8 rounded-2xl shadow-md hover:shadow-xl transition-shadow duration-300 text-center cursor-pointer transform hover:-translate-y-1"
            >
              <div className="text-indigo-600 mb-6 flex justify-center transition-transform duration-300 group-hover:scale-110">
                {service.icon}
              </div>
              <h3 className="text-2xl font-semibold mb-4 text-gray-900">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
